import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment.development';
import { requestWithToken, requestWithoutToken } from 'src/config';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  async fetchFooter(language: any) {
    return requestWithoutToken(
      "GET",
      `/masters/meta/footer/en`
    ).then((res) => {
      return res?.data;
    }).catch((error) => {
      return error;
    })
  }


  async fetchLanguage() {
    return requestWithToken(
      "GET",
      `/admin/master/lang`
    ).then((res) => {
      return res?.data;
    }).catch((error) => {
      return error;
    })
  }

  async fetchPlaces(value: string) {
    return requestWithoutToken(
      "GET",
      `/marketplace/auto-complete?kw=${value}`
    ).then((res) => {
      return res?.data;
    }).catch((error) => {
      return error;
    })
  }


  async fetchMarketPlaceScreenData() {
    return requestWithoutToken(
      "GET",
      `/masters/meta/store/en`
    ).then((res) => {
      return res?.data;
    }).catch((error) => {
      return error;
    })
  }

  async fetchMarketPlace() {
    return requestWithoutToken(
      "GET",
      `/marketplace`
    ).then((res) => {
      return res?.data;
    }).catch((error) => {
      return error;
    })
  }

  async searchMarketPlace(lat: any, lng: any, keyword: any, place: any) {
    return requestWithoutToken(
      "GET",
      place ?
        `/marketplace/search?placeId=${place}&keyword=${keyword}` :
        lat ?
          `/marketplace/search?lat=${lat}&lng=${lng}&keyword=${keyword}`
          :
          `/marketplace/search?keyword=${keyword}`
    ).then((res) => {
      return res?.data;
    }).catch((error) => {
      return error;
    })
  }

  async getProductDetails(title: any) {
    return requestWithoutToken(
      "GET",
      `/marketplace/products?productName=${title}`
    ).then((res) => {
      return res?.data;
    }).catch((error) => {
      return error;
    })
  }
}
